export function useUserAgent() {
  const ua = useDevice().userAgent

  return {
    isInWechat: isInWechat(ua),
    isInTencent: isInWechat(ua) || isInQQWebview(ua)
  }
}

function isInWechat(ua: string) {
  // console.log('ua', ua, ua.match(/MicroMessenger/i) !== null)
  return ua.match(/MicroMessenger/i) !== null
}

// ios qq浏览器
// Mozilla/5.0 (iPhone; CPU iPhone OS 17_3_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.0 MQQBrowser/14.9.6 Mobile/ 15E148 Safari/604.1 QBWebViewUA/2 QB WebViewType/1 WKType/1
// ios qq内置webview
// Mozilla/5.0 (iPhone; CPU iPhone OS 17_3_1 like Mac OS X) AppleWebKit/6 05.1.15 (KHTML, like Gecko) Mobile/1 5E148 QQ/9.0.17.638 V1_IPH_SQ_9.0 .17_1_APP_A Pixel/1179 MiniAppEnabl e SimpleUlSwitch/1 StudyMode/0 Cu rrentMode/1 CurrentFontScale/1.000 000 QQTheme/2971 Appld/5372032 42 Core/WKWebView Device/Apple(i Phone X) NetType/WIFI QBWebViewT ype/1 WKType/1
// android qq浏览器 或老版本android app内x5内核
// Mozilla/5.0 (Linux; U; Android 13; zh-cn; M2102J2SC Build/ TKQ1.220829.002) AppleWebKit/537.36 (KHTML, like Gecko) Version/ 4.0 Chrome/109.0.5414.86 MQQBrowser/14.9 Mobile Safari/537.36 COVC/047001
// android qq内置webview
// Mozilla/5.0(Linux; Android 13: M2102J2SC Build/TKQ1.220829.002: wv)AppleWebKit/537.36(KHTML ike Gecko) Version/4.0 Chromel 109.0.5414.86 MQQBrowser/6.2 TBS/046725 Mobile Safari/537.36 V1 AND SQ 8.3.9 356 TIM D QQ/ 3.5.6.3208 NetType/WIFI WebP/ 0.3.0 Pixel/1080 StatusBarHeight/90 SimpleUISwitch/0 QQTheme/1015712

// qq内webview
function isInQQWebview(ua: string) {
  // 空格 + qq
  return /\sqq/i.test(ua)
}
